module.exports = __webpack_public_path__ + "static/media/11.cfc814a6.svg";